import React, { FC, SVGProps } from 'react';

export const DoubleCaret: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        strokeWidth="3"
        d="M15.1774 0.555515L15.8644 1.27868C16.0452 1.42331 16.0452 1.71258 15.8644 1.89337L8.30734 9.45043C8.12655 9.63122 7.87345 9.63122 7.69266 9.45043L0.135593 1.89337C-0.0451977 1.71258 -0.0451977 1.42331 0.135593 1.27868L0.822599 0.555515C1.00339 0.374724 1.29266 0.374724 1.43729 0.555515L8.01808 7.10015L14.5627 0.555515C14.7073 0.374724 14.9966 0.374724 15.1774 0.555515ZM15.1774 8.55552L15.8644 9.27868C16.0452 9.42331 16.0452 9.71258 15.8644 9.89337L8.30734 17.4504C8.12655 17.6312 7.87345 17.6312 7.69266 17.4504L0.135593 9.89337C-0.0451977 9.71258 -0.0451977 9.42331 0.135593 9.27868L0.822599 8.55552C1.00339 8.37472 1.29266 8.37472 1.43729 8.55552L8.01808 15.1001L14.5627 8.55552C14.7073 8.37472 14.9966 8.37472 15.1774 8.55552Z"
      />
    </svg>
  );
};
